export default __webpack_public_path__ + "assets/icons/apply_no.f8e49743.svg";